import Autocomplete from 'common/autocomplete';
import { IKeyAnyValue } from 'common/types';
import { IModalComponent, Modal } from 'contexts/modalFunc';

const Modals: IKeyAnyValue = {
  [Modal.ARRIVALS]: (props: any) => <Autocomplete {...props} />,
  [Modal.ARRIVALS_EVERYWHERE]: (props: any) => (
    <Autocomplete {...props} isEverywhere />
  ),
  [Modal.DEPARTURES]: (props: any) => <Autocomplete forDeparture {...props} />,
  [Modal.DEPARTURES_EVERYWHERE]: (props: any) => (
    <Autocomplete {...props} forDeparture isEverywhere />
  ),
};

const AutocompleteModalContainer = ({
  modalInfo: { type, payload },
  isSearchBoxFixed,
}: IModalComponent) => {
  const ModalComponent = Modals[type];
  if (!ModalComponent) return null;
  return (
    <ModalComponent payload={payload} isSearchBoxFixed={isSearchBoxFixed} />
  );
};

export default AutocompleteModalContainer;
